import { TListingFetchReason, TRESPONSE_HOLIDAY_LIST } from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TConfigSetupState = {
  holidayListingInfo: {
    res: TRESPONSE_HOLIDAY_LIST;
    fetchReason: TListingFetchReason;
  } | null;
  holidayListingPagination: TUserPaginationOption;
};

export const TConfigSetupActionType = {
  GetHolidayList: 'GET_HOLIDAY_LIST' as const,
  GetHolidayListSuccess: 'GET_HOLIDAY_LIST_SUCCESS' as const,
  GetHolidayListFailure: 'GET_HOLIDAY_LIST_FAILURE' as const,
  SetHolidayListPagination: 'SET_HOLIDAY_LIST_PAGINATION' as const,
  AddHolidays: 'ADD_HOLIDAYS' as const,
  AddHolidaysFailure: 'ADD_HOLIDAYS_SUCCESS' as const,
  AddHolidaysSuccess: 'ADD_HOLIDAYS_FAILURE' as const,
  DeleteHolidays: 'DELETE_HOLIDAYS' as const,
  DeleteHolidaysFailure: 'DELETE_HOLIDAYS_SUCCESS' as const,
  DeleteHolidaysSuccess: 'DELETE_HOLIDAYS_FAILURE' as const,
  EditHoliday: 'EDIT_HOLIDAY' as const,
  EditHolidayFailure: 'EDIT_HOLIDAY_FAILURE' as const,
  EditHolidaySuccess: 'EDIT_HOLIDAY_SUCCESS' as const,
};
